import { defineStore } from "pinia";

export interface QuickRegisterStep1Data {
  // Informações pessoais
  kindOfPerson: "NATURAL_PERSON" | "LEGAL_PERSON";
  email: string;
  emailConfirmation: string;
  legalName: string;
  regNumber: string;
  phone: string;

  // Endereço
  postalCode: string;
  addressLine1: string;
  addressNumber: string;
  addressLine2?: string;
  addressLine3?: string;
  city: string;
  state: string;

  // Informações de pagamento
  cardNumber: string;
  cardHolderName: string;
  cardExpiryMonth: string;
  cardExpiryYear: string;
  cardCcv: string;
}

export const useQuickRegisterStore = defineStore({
  id: "quickRegister",
  state: () => {
    const sessionData = sessionStorage.getItem("quick_register_step1");
    const step1Data = sessionData ? JSON.parse(sessionData) : null;
    const token = sessionStorage.getItem("quick_register_token");
    const userId = sessionStorage.getItem("quick_register_user_id");
    const subscriptionId = sessionStorage.getItem("quick_register_subscription_id");
    const subscriptionCreated = sessionStorage.getItem("quick_register_subscription") === "true";

    return {
      step1Data: step1Data as QuickRegisterStep1Data | null,
      token: token || null,
      userId: userId || null,
      subscriptionId: subscriptionId || null,
      subscriptionCreated: subscriptionCreated,
    };
  },
  getters: {
    hasStep1Data: (state) => !!state.step1Data,
    hasToken: (state) => !!state.token,
    isSubscriptionCreated: (state) => state.subscriptionCreated,
  },
  actions: {
    saveStep1Data(data: QuickRegisterStep1Data) {
      this.step1Data = data;
      sessionStorage.setItem("quick_register_step1", JSON.stringify(data));
    },

    saveStep1Result(token: string, userId: string, subscriptionId: string) {
      this.token = token;
      this.userId = userId;
      this.subscriptionId = subscriptionId;
      this.subscriptionCreated = true;

      sessionStorage.setItem("quick_register_token", token);
      sessionStorage.setItem("quick_register_user_id", userId);
      sessionStorage.setItem("quick_register_subscription_id", subscriptionId);
      sessionStorage.setItem("quick_register_subscription", "true");
    },

    markSubscriptionCreated() {
      this.subscriptionCreated = true;
      sessionStorage.setItem("quick_register_subscription", "true");
    },

    clearData() {
      this.step1Data = null;
      this.token = null;
      this.userId = null;
      this.subscriptionId = null;
      this.subscriptionCreated = false;

      sessionStorage.removeItem("quick_register_step1");
      sessionStorage.removeItem("quick_register_token");
      sessionStorage.removeItem("quick_register_user_id");
      sessionStorage.removeItem("quick_register_subscription_id");
      sessionStorage.removeItem("quick_register_subscription");
    },
  },
});
